import { fetchApi } from '@/config/axiosSetting.ts';
import { WalletBalanceQueryResponseType } from '@/modules/Dashboard/queries/walletBalance/walletBalanceQuery.type.ts';

export const walletBalanceQueryFunction =
  (): Promise<WalletBalanceQueryResponseType> =>
    fetchApi.get('homepage/wallet/balance/');
